module.exports = __webpack_public_path__ + "img/staff-brad-hinds.bb38be2e.jpg";